import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { List } from 'immutable';
import {jsxActions as alertedRollsPageActions} from '../../actions/AlertedRollsPage/alertedRollsPageActions';
import {jsxActions as headerActions} from '../../actions/Header/headerActions';
import {gridsNames} from '../../enums/gridsNames';

import { jsxActions as shelfLifeUpdateActions } from '../../actions/Dialogs/ShelfLifeUpdateDialog/shelfLifeUpdateDialogActions';
import { jsxActions as alertedRollsGridActions } from '../../actions/AlertedRollsPage/alertedRollsGridActions';
import { jsxActions as archiveAssetsActions }   from '../../actions/Dialogs/ArchiveAssetsDialog/archiveAssetsDialogActions';
import { jsxActions as moveAssetsActions }      from '../../actions/Dialogs/MoveAssetsDialog/moveAssetsDialogActions';
import { jsxActions as editAssetAttributesActions }      from '../../actions/Dialogs/EditAssetAttributesDialog/editAssetAttributesDialogActions.js';
import { jsxActions as printPdfLabelsActions }      from '../../actions/Dialogs/PrintPdfLabelsDialog/printPdfLabelsDialogActions.js';
import { jsxActions as fetchEntitiesActions }      from '../../actions/FetchEntities/fetchEntitiesActions.js';
import {jsxActions as exportActions} from '../../actions/Export/exportActions';
import { jsxActions as importAttributesUpdateWizardActions} from '../../actions/Wizards/ImportAttributesUpdateWizard/importAttributesUpdateWizardActions.js';

import AlertedRollsPage from '../../components/PredefinedList/AlertedRollsPage/alertedRollsPage';


function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(alertedRollsPageActions, dispatch),
      header: bindActionCreators(headerActions, dispatch),
      fetchEntitiesActions:    bindActionCreators(fetchEntitiesActions, dispatch),
      alertedRollsGridActions: bindActionCreators(alertedRollsGridActions, dispatch),
      shelfLifeUpdateActions:   bindActionCreators(shelfLifeUpdateActions, dispatch),
      archiveAssetsActions:     bindActionCreators(archiveAssetsActions, dispatch),
      moveAssetsActions:      bindActionCreators(moveAssetsActions, dispatch),
      editAssetAttributesActions:      bindActionCreators(editAssetAttributesActions, dispatch),
      printPdfLabelsActions:      bindActionCreators(printPdfLabelsActions, dispatch),
      exportActions:      bindActionCreators(exportActions, dispatch),
      importAttributesUpdateWizardActions: bindActionCreators(importAttributesUpdateWizardActions, dispatch),
    }
  }
}

let AlertedRollsPageContainer = connect(
  (state) => {
    let alertedRollsGrid = state.grid.get(gridsNames.PREDEFINED_LIST_ALERTED_ROLLS) ? state.grid.get(gridsNames.PREDEFINED_LIST_ALERTED_ROLLS) : null;
    return {
      sAlertedRollsGrid:  alertedRollsGrid,
      sHasRows: alertedRollsGrid && alertedRollsGrid.get('rows') ? alertedRollsGrid.get('rows').size > 0 : false,
      sSelectedRowsData: alertedRollsGrid ? alertedRollsGrid.get('selectedRowsData') : List(),
      sShelfLifeUpdateData: state.dialogs.get('shelfLifeUpdateDialog'),
      sArchiveAssetsData:   state.dialogs.get('archiveAssetsDialog'),
      sMoveAssetsData:      state.dialogs.get('moveAssetsDialog'),
      sEditAssetAttributesData: state.dialogs.get('editAssetAttributesDialog'),
      sPrintPdfLabelsData: state.dialogs.get('printPdfLabelsDialog'),
      sLoggedInUser : state.login.get('loggedInUser'),
      sImportAttributesUpdateWizardData: state.wizards.get('importAttributesUpdateWizard'),
    };
  },
  mapDispatchToProps
)(AlertedRollsPage);


export default AlertedRollsPageContainer;



